import { combineReducers } from 'redux'
import familytree from './familytree/reducer'
import cppestimator from './cppestimator/reducer'
import cppoptimizer from './cppoptimizer/reducer'

export const apps = combineReducers({
	familytree,
	cppestimator,
	cppoptimizer
})